import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter basename={baseUrl}>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_API_KEY}>
        <App />
    </GoogleOAuthProvider>
    </BrowserRouter>
);